import TranslationUtil from '../../utils/TranslationUtil';


export const genericFireAction = (store, actionGenerator, payload = {}) => {
    store.dispatch(actionGenerator(payload));
};

export const translateValidationResult = (result, store, payload = {}) => {
    const { translations, fallbackTranslations } = store.getState().app;
    const translationUtil = new TranslationUtil(translations, fallbackTranslations);
    const error = result.isValid ? undefined : translationUtil.getTranslation(
        result.errorMessageKey,
        result.errorMessageParams
    );

    return ({
        ...payload,
        isValid: result.isValid,
        error,
        errorCode: result.errorMessageKey
    });
};

export const fireValidationAction = (result, store, actionGenerator, payload = {}) => {
    const translatedResult = translateValidationResult(result, store, payload);
    genericFireAction(store, actionGenerator, translatedResult);
};

export default {
    fireValidationAction,
    genericFireAction,
    translateValidationResult
};
